// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    JIRA_SEARCH_DETAILS_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    jiraSearchDetailsResult,
} from 'Redux/actions';

// Helpers
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* searchDetails({ payload }) {
    try {
        let QUERY = `
            query searchJiraSummary ($dateRange: AWSDateTimeRange!, $developer: String, $jiraTask: String, $sort: JiraSummarySortInput) {
                result: searchJiraSummary (dateRange: $dateRange, developer: $developer, jiraTask: $jiraTask, sort: $sort) {
                    name
                    country
                    holidays
                    original {
                        jiraTask
                        summary
                        storyPoints
                        stageFrom
                        stageTo
                        start
                        end
                    }
                    times {
                        jiraTask
                        overlaps
                        start
                        end
                        timeHours
                    }
                    totalTimeHours
                    totalTimeHoursGSD
                    totalTimeHoursOthers
                    totalStoryPoints
                    totalStoryPointsGSD
                    totalStoryPointsOthers
                    tasksPeriod
                    taskPeriodGSD
                    taskPeriodOthers
                    rejections {
                        jiraTask
                        rejections
                        manualRejections
                        summary
                    }
                    responsibleForTasks{
                        jiraTask
                        summary
                        issueType
                    }
                    totalRejectedTasks
                    totalRejections
                    daysPeriod
                    kpi {
                        quality
                        estimation
                        participation
                        total
                    }
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data.result.length) {
            const { result } = data
            yield put(jiraSearchDetailsResult(result[0]))
        } else {
            yield put(jiraSearchDetailsResult(null))
        }

    } catch (exc) {
        ExceptionManager(
            exc,
            'Modules/pmUsers/views/jiraSummary/.components/userDetails/redux/saga',
            'searchDetails'
        );
        yield put(jiraSearchDetailsResult(null))
    }
}

function* watchMethods() {
    yield takeEvery(JIRA_SEARCH_DETAILS_REQUEST, searchDetails);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}